import { render, staticRenderFns } from "./sms_module.vue?vue&type=template&id=7dd47db6&scoped=true"
import script from "./sms_module.vue?vue&type=script&lang=js"
export * from "./sms_module.vue?vue&type=script&lang=js"
import style0 from "./sms_module.vue?vue&type=style&index=0&id=7dd47db6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dd47db6",
  null
  
)

export default component.exports